import { BouSpacingLevel, fluidHorizontalPadding } from './bou-spacing';

export const HEADER_HEIGHT_PX = '48px';
export const TITLE_BAR_HEIGHT_PX = '60px';

/**
 * Custom property carrying the height of the fixed top bar currently on screen, published by
 * `MainRoot` and read by everything that has to clear it.
 *
 * Two bars can occupy that strip and they are different heights: the dark `BouToolHeader` is
 * `HEADER_HEIGHT_PX`, and the unified shell's white bar is the design system's 50px
 * (design/40-shell-and-pages.md "Top bar"). Which one a user gets depends on their shell opt-in,
 * which is a runtime answer, so the offset has to reach these styled-components through the
 * cascade rather than through an import.
 */
export const APP_HEADER_HEIGHT_VAR = '--app-header-height';

/**
 * Height of the unified shell's white top bar. A literal, because 50px is the design system's
 * top-bar height (design/40-shell-and-pages.md "Top bar") and it is on no token scale. The shell's
 * own CSS restates it as `--unified-shell-header-height`, which a stylesheet cannot import.
 */
export const UNIFIED_HEADER_HEIGHT_PX = '50px';

/**
 * The value to write into a `top`, `padding-top` or `calc()` that has to sit below the fixed top
 * bar. Use this rather than `HEADER_HEIGHT_PX` directly: the constant is the dark bar's own
 * height and, as the fallback here, what applies before `MainRoot` has published anything.
 */
export const appHeaderHeight = `var(${APP_HEADER_HEIGHT_VAR}, ${HEADER_HEIGHT_PX})`;

/**
 * Height of the internal-tools breadcrumb bar (the bar rendered on every
 * /internal page). It is intentionally shorter than the entity TITLE_BAR_HEIGHT_PX,
 * but tall enough to give the breadcrumb text — and any right-aligned actions
 * (e.g. the products view's "Mode" / "Create…" menus) — a bit of vertical
 * breathing room. Internal frames offset their content by this value (via
 * `titleBarHeight` on `BouPageWithFrame`) instead of TITLE_BAR_HEIGHT_PX.
 */
export const INTERNAL_BREADCRUMBS_HEIGHT_PX = '48px';

export const BOU_TOOL_PAGE_CONTENT_MIN_HEIGHT = 'calc(100vh - 360px)';
export const BOU_TOOL_BOTTOM_BAR_FIXED_HEIGHT = 25;

export const bouSideBarPadding = `
  ${fluidHorizontalPadding(BouSpacingLevel.TINYISH)}
`;

/**
 * Set on a container that already insets its content, the unified profile frame. Legacy blocks
 * inside it drop their own horizontal inset, so every block starts on the page title's left edge
 * (design/40-shell-and-pages.md). An attribute rather than a context, because the inset below is a
 * string spliced into some thirty styled-components and cannot read one.
 */
export const LEGACY_INSET_NONE_ATTRIBUTE = 'data-legacy-inset-none';

export const bouToolCommonBoxPadding = `
  ${fluidHorizontalPadding(BouSpacingLevel.SMALL)}
  [${LEGACY_INSET_NONE_ATTRIBUTE}] & {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const SCROLLING_CONTAINER_ID = 'bou-tool-page-with-frame';
